import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class DocumentRefService {
    constructor(@Inject(DOCUMENT) private document: Document) {}

    get documentElement(): HTMLElement {
        return this.document.documentElement;
    }

    getElementById(id: string): HTMLElement {
        return this.document.getElementById(id);
    }

    setDocumentProperty(property: string, value: string): void {
        this.document.documentElement.style.setProperty(property, value);
    }

    setElementAttribute(element: string, attribute: string, value: string): void {
        this.document.getElementById(element).setAttribute(attribute, value);
    }

    createElement(element: string): HTMLElement {
        return this.document.createElement(element);
    }

    appendChild(element: HTMLElement) {
        this.document.body.appendChild(element);
    }

    removeChild(element: HTMLElement) {
        this.document.body.removeChild(element);
    }

    isFullscreenMode(): boolean {
        return !!this.document.fullscreenElement;
    }

    exitFullscreen() {
        this.document.exitFullscreen().catch(() => {});
    }

    generateUniqueElementId(): string {
        return this.generateId();
    }

    private generateId(): string {
        const id = `element-${Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER - 1)) + 1}`;

        if (this.getElementById(id)) {
            return this.generateId();
        }

        return id;
    }
}
